<template>
    <Breadcrumb :style="{margin: '24px 0'}">
        <BreadcrumbItem>管理中心</BreadcrumbItem>
        <BreadcrumbItem>站点管理</BreadcrumbItem>
        <BreadcrumbItem>内容管理</BreadcrumbItem>
    </Breadcrumb>
</template>